<template>
  <div class="flex flex-col h-screen">
    <NuxtLoadingIndicator :height="3" :duration="3000" color="rgb(var(--color-primary))" />
    <div v-if="!isProd" class="bg-red-500 text-white text-center py-2 flex-shrink-0">
      Local Development Environment
    </div>
    <div v-else-if="isStaging" class="bg-yellow-500 text-white text-center py-2 flex-shrink-0">
      Staging Environment
    </div>
    <AppHeader class="flex-shrink-0" />
    <LoadingOverlay v-if="isAuthChecking && !isIndexPage" />

    <main class="flex-1 overflow-y-auto">
      <slot />
    </main>

    <!-- Background image container with full width coverage -->
    <div
      v-if="isIndexPage || isAuth"
      class="fixed left-0 top-0 right-0 bottom-0 z-[-1] pointer-events-none"
      style="
        background-image: url('/images/back_optimized.png');
        background-size: 100% auto;
        background-position: bottom center;
        background-repeat: no-repeat;
      "
    ></div>
  </div>
</template>

<script setup>
import { ref, onMounted, computed, onUnmounted, watch } from 'vue'
import { useRoute } from 'vue-router'
import { useUserStore } from '@/stores/user'

const userStore = useUserStore()
const route = useRoute()
const isAuthChecking = computed(() => userStore.isAuthChecking)
const isMobileOrSmall = ref(false)
const config = useRuntimeConfig()
const isProd = config.public.isProd
const isStaging = computed(() => config.public.isStaging)

const isIndexPage = computed(() => route.name === 'index')
const isAuth = computed(() => route.name === 'auth')

const checkViewportSize = () => {
  isMobileOrSmall.value = window.innerWidth < 768 // Adjust this breakpoint as needed
}

onMounted(async () => {
  checkViewportSize()
  window.addEventListener('resize', checkViewportSize)

  // Set body class on initial load
  if (import.meta.client && (isIndexPage.value || isAuth.value)) {
    document.body.classList.add('no-overflow')
  }
})

onUnmounted(() => {
  window.removeEventListener('resize', checkViewportSize)

  // Remove body class on unmount
  if (import.meta.client) {
    document.body.classList.remove('no-overflow')
  }
})

// Update the body class to prevent overflow on index/auth pages
watch(
  [isIndexPage, isAuth],
  ([newIsIndexPage, newIsAuth]) => {
    if (import.meta.client) {
      if (newIsIndexPage || newIsAuth) {
        document.body.classList.add('no-overflow')
      } else {
        document.body.classList.remove('no-overflow')
      }
    }
  },
  { immediate: true }
)
</script>

<style scoped>
/* Ensure the body doesn't overflow when background is present */
:deep(body),
:deep(html) {
  overflow-x: hidden;
  /* max-height: 100vh; */
}

/* Global style to prevent overflow when on index or auth pages */
body.no-overflow {
  overflow: hidden !important;
  height: 100vh !important;
  max-height: 100vh !important;
}
</style>
